import type { SVGProps } from 'react'
const SvgLinkedInTextLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#fff" clipPath="url(#a)">
      <path d="M6.598 7.8h-4.2v13.8h4.2zM16.8 7.8c-2.4 0-3.066.786-3.6 1.8V7.8H9v13.8h4.2v-7.8c0-1.2 0-2.4 2.1-2.4s2.1 1.2 2.1 2.4v7.8h4.2v-7.8c0-3.6-.6-6-4.8-6M4.498 6.6a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.398 2.4h19.2v19.2h-19.2z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgLinkedInTextLogo
